<fui-pill-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()"
                 [hovered]="hovered">
    <fui-fixtures>
        <fui-fixture *ngIf="!disabled">
            <fui-icon [height]="12" [icon]="'clock'" [width]="12"
                      [clickable]="true" (click)="toggle($event)"></fui-icon>
        </fui-fixture>
        <fui-fixture>
            <fui-pill-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                            [title]="label"></fui-pill-label>
        </fui-fixture>
        <fui-spanning-fixture>
            <fui-input-dom>
                <kendo-dateinput #input [(ngModel)]="value" (focus)="onFocus($event)" (blur)="onBlur($event)"
                                 [format]="'h:mm a'" [disabled]="disabled" [tabindex]="tabindex"></kendo-dateinput>
            </fui-input-dom>
        </fui-spanning-fixture>
        <fui-fixture>
            <fui-mark-button (click)="remove()">
                <fui-icon [height]="6" [icon]="'close'" [width]="6"></fui-icon>
            </fui-mark-button>
        </fui-fixture>
    </fui-fixtures>
</fui-pill-fascia>
<fui-time-pop [popped]="popped" (popped$)="pop($event)" (click)="popClicked($event)">
    <ng-container *ngIf="popped">
        <fui-time-selector *ngIf="popped" #selector [(value)]="value" (valueChange)="selectorChanged($event)"></fui-time-selector>
    </ng-container>
</fui-time-pop>
